<template>
  <div class="copy-wrap">
    <resize-container :tabShow="tabShow">
      <div class="tree-content box" v-show="tabShow" slot="left">
        <tab-tree
          :data="viewTreeData"
          :checkbox="true"
          @tabTreeDefault="tabTreeDefault"
          @change="tabTreeChange"
          :showCascade="false"
          :includeHalfChecked="true"
          @changeCompany="changeCompany"
        ></tab-tree>
      </div>
      <div class="right-content">
        <div class="search-box box">
          <time-search
            ref="timeSearch"
            :control="{ data: timeData }"
            @timeControlClick="TimeControlClick"
            :showExportBtn="true"
            :showOperation="true"
            @operationTree="operationTree"
            @exportExc="bindExportExc"
          >
          </time-search>
        </div>
        <div class="table-content box table-warp" v-loading="loading">
          <el-table
            row-key="id"
            :data="bottomTableData"
            ref="table2"
            id="table"
            :height="'100%'"
            :default-expand-all="expandAll"
            :stripe="true"
            style="overflow: auto"
          >
            <template v-for="(item, index) in columns">
              <el-table-column
                v-if="item.show != false"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :align="item.align ? item.align : 'center'"
                :width="item.width"
                :formatter="item.formatter"
              ></el-table-column>
            </template>
          </el-table>
        </div>
      </div>
    </resize-container>
  </div>
</template>
<script>
import {
  findDataByParam,
  dateToColumns,
  toPage,
  exportExcel,
  arrToTreeDataLh,
} from "@/utils/index.js";
import NkTree from "@/components/common/NkTree.vue";
import TabTree from "@/components/common/TabTree.vue";
import TimeSearch from "@/components/common/TimeSearch.vue";
import dateTool from "@/utils/dateTool";
import * as utils from "@/utils/index.js";
import tree from "@/utils/tree.js";
import { isNull, isUndefined } from "util";
import echarts from "echarts";
import ResizeContainer from "@/components/common/resizeContainer.vue";
import { nextTick } from "process";
let allTimeData = [
  {
    type: "day",
    label: "日",
  },
  {
    type: "month",
    label: "月",
  },
  {
    type: "year",
    label: "年",
  },
];
export default {
  data() {
    return {
      tabShow: true,
      page: {
        //操作页面
        pageSizes: [10, 20, 50, 100, 500, 1000], //每页显示条目个数
        size: 10,
        pageIndex: 1,
        total: 0,
      },
      loading: false,
      timeData: allTimeData,
      checkedNodeArrs: [],
      dataType: "0",
      nodeData: [], //选择的树节点
      treeData: {},
      treeTabObj: null,
      treeBtnList: [], //树类型
      treeList: [], //具体的树类型的分类
      tree: [], //具体的树类型，树分类后的详细数据
      columns: [
        { prop: "name", label: "计量点名称", show: true, align: "left" },
        // {
        //   prop: "DistributionCabinet",
        //   label: "电表柜号",
        //   show: true,
        //   width: "120",
        //   align: "left",
        // }, //流花特有，其他公司隐藏
        // {
        //   prop: "MeasureNumber",
        //   label: "电表编号",
        //   show: true,
        //   width: "120",
        //   align: "left",
        // }, //流花特有，其他公司隐藏
        {
          prop: "comprehensiveRatio",
          label: "综合倍率",
          show: true,
          width: "120",
          align: "left",
        },
        {
          prop: "previousMeterReading",
          label: "上期读数",
          show: true,
          width: "120",
          align: "right",
          formatter: (row) => this.formatValue(row.previousMeterReading),
        },
        {
          prop: "previousMeterReadingDate",
          label: "上期读数时间",
          show: true,
          width: "160",
          align: "right",
        },
        {
          prop: "presentMeterReading",
          label: "本期读数",
          show: true,
          width: "120",
          align: "right",
          formatter: (row) => this.formatValue(row.presentMeterReading),
        },
        {
          prop: "presentMeterReadingDate",
          label: "本期读数时间",
          show: true,
          width: "160",
          align: "right",
        },
        {
          prop: "value",
          label: "本期用量",
          show: true,
          width: "120",
          align: "right",
          formatter: (row) => this.formatValue(row.value),
        },
      ],
      bottomTableData: [],
      selectedDate: {},
      viewTreeData: [],
      matchData: [],
      pointCode: "401",
      expandAll: false,
    };
  },
  created() {},
  mounted() {},
  watch: {
    nodeData(curval, oldval) {
      let vm = this;
      let checkedArr = curval;
      this.getTableData(1);
    },
  },
  methods: {
    /* 切换公司树 */
    changeCompany(companyId) {
      let vm = this;
      vm.$api.frontEndPageCustomParam
        .getMyFrontEndPageCustomParam(companyId, "/report/ddtjbb", null)
        .then((res) => {
          const viewTreeData = findDataByParam("viewTree", true, res.data);
          vm.viewTreeData = viewTreeData;
        });
    },
    //导出
    bindExportExc() {
      let name = "电度统计报表";
      utils.exportExcel("table", name, this.selectedDate);
    },
    //查询事件
    TimeControlClick(e) {
      let vm = this;
      vm.selectedDate = e;
      // vm.selectedDate.dataType = e.dateType;
      this.getTableData(1);
    },
    operationTree(flag) {
      //展开与折叠
      const data = this.$refs.table2.data;
      this.recursionTreeData(data, this.$refs.table2, flag);
    },
    recursionTreeData(data, tabelElem, flag) {
      //数据源、表格元素、展开还是折叠
      for (let i = 0; i < data.length; i++) {
        tabelElem.toggleRowExpansion(data[i], flag);
        if (data[i].children && data[i].children.length > 0) {
          this.recursionTreeData(data[i].children, tabelElem, flag);
        }
      }
    },
    getTableData(pageIndex) {
      let vm = this;
      vm.loading = true;
      let pointCode = vm.dataType == "1" ? vm.pointCode : "100" + vm.pointCode;
      let pointCode_ = vm.pointCode;
      let segments = null,
        pricingMode = null,
        limit = "1";
      let startTime = this.selectedDate.startTime;
      let endTime = this.selectedDate.endTime;
      let apiArr = [];
      let checkedNodeArrs = JSON.parse(JSON.stringify(vm.checkedNodeArrs));
      const pageSize = 300;
      if (checkedNodeArrs.length > 0) {
        let total = Math.ceil(checkedNodeArrs.length / pageSize);
        for (let index = 0; index < total; index++) {
          //id
          const spliceArr = checkedNodeArrs.slice(
            index * pageSize,
            (index + 1) * pageSize
          );
          let ids = []; //用电
          let meaId = []; //计量点
          let idsBm = []; //表码
          for (let j = 0; j < spliceArr.length; j++) {
            ids.push({
              measureId: spliceArr[j].measureId,
              pointCode: pointCode,
              pointNumber: "0",
            });
            idsBm.push({
              measureId: spliceArr[j].measureId,
              pointCode: pointCode_,
              pointNumber: "0",
            });
            meaId.push(spliceArr[j].measureId);
          }
          let apiOne = null;
          let requestUrl = "";
          if (vm.selectedDate.dateType === "day") {
            requestUrl = this.$api.quantity.getQuantityDay5;
          } else if (vm.selectedDate.dateType === "month") {
            requestUrl = this.$api.quantity.getQuantityMonth2;
          } else {
            requestUrl = this.$api.quantity.getQuantityYear2;
          }
          apiOne = requestUrl(
            JSON.stringify(ids),
            startTime,
            endTime,
            segments
          );

          apiArr.push(
            apiOne,
            this.$api.measure.getMultiMeasurePointedProperty({
              measureIds: JSON.stringify(meaId),
              ptyNames: JSON.stringify(["__meterReadingMultiplier"]),
            })
          );
        }
        Promise.all(apiArr).then((res) => {
          if (res.length == 0) {
            vm.bottomTableData = [];
          } else {
            res.forEach((item) => {
              if (!item.success) {
                vm.$message.error(item.msg);
              }
            });
            vm.loading = false;
            let curuse = this.ordinaryData(res[0].data, res[1].data);
            vm.bottomTableData = arrToTreeDataLh(curuse, 0); //转为树格式
          }
        });
      } else {
        vm.bottomTableData = [];
        vm.loading = false;
      }
    },
    ordinaryData(arr, props) {
      let needarr = JSON.parse(JSON.stringify(this.checkedNodeArrs));
      return needarr.map((item) => {
        const comprehensiveRatio =
          props.find((i) => i.measureId === item.id)?.value || "-";
        return {
          ...item,
          ...arr.find((i) => i.measureId === item.id).data[0],
          comprehensiveRatio,
        };
      });
    },
    formatValue(value) {
      if (value === 0) {
        return 0;
      } else if (!value) {
        return "-";
      } else {
        return (+value).toFixed(2);
      }
    },
    /**
     * 处理数字和公式
     */
    hanlerNumOrCalc(str) {
      const num = Number(str);
      if (num + "" !== "NaN") {
        return num;
      } else {
        const total = eval(str);
        return total;
      }
    },
    //设置表头颜色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      //改表头颜色
      if (rowIndex === 0) {
        return "background-color: #F3F3F3;color: #666;";
      }
    },
    //树默认加载
    tabTreeDefault(node, pointCode) {
      let vm = this;
      vm.pointCode = pointCode;
      let dataType = vm.dataType;
      let measureIdS = vm.deep([node]);
      vm.checkedNodeArrs = [];
      vm.matchData = [];
      measureIdS.forEach((item) => {
        vm.checkedNodeArrs.push(item);
        vm.matchData.push(item);
      });
      nextTick(() => {
        this.$refs.timeSearch.bindQuery();
      });
    },
    tabTreeChange(nodes, ids, data) {
      let vm = this;
      let dataType = vm.dataType;
      vm.checkedNodeArrs = [];
      let isPush = false;
      data.forEach((item) => {
        item.name = item.measureName;
        vm.checkedNodeArrs.push(item);
      });
      vm.getTableData(1);
    },
    /**
     * 树转数组扁平化结构
     * 深度优先遍历  堆栈  后进先出
     */
    deep(node) {
      let stack = node,
        data = [];
      while (stack.length != 0) {
        let pop = stack.pop();
        data.push({
          id: pop.id,
          name: pop.measureName,
          parentId: pop.parentId,
          measureId: pop.measureId,
        });
        let children = pop.children;
        if (children) {
          for (let i = children.length - 1; i >= 0; i--) {
            stack.push(children[i]);
          }
        }
      }
      return data;
    },
  },
  components: { TabTree, TimeSearch, ResizeContainer },
};
</script>
<style lang="scss" scoped>
.copy-wrap {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  display: flex;
}
.tree-content {
  width: 100%;
  margin-right: 14px;
}
.right-content {
  display: flex;
  flex-flow: column;
  width: 100%;
  height: 100%;
}
.search-box {
  height: 36px;
}
.table-content {
  width: 100%;
  margin-top: 14px;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex: 1;
}
.page {
  text-align: right;
  padding: 14px 0px;
  box-sizing: border-box;
}
</style>
